import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const NoDataMessage = (props) => {
  const { type, message, noTopMargin = false } = props;

  const handleShowALlNoDataImages = useMemo(() => {
    switch (type) {
      case 'NO_TEAMS': {
        return (
          <img
            className="justify-content-center"
            src={require('../../static/img/No-data-messages/No-Teams.png')}
            height="160px"
            width="160px"
            alt="No-data"
          />
        );
      }
      case 'NO_TXN_LIST': {
        return (
          <img
            className="justify-content-center"
            src={require('../../static/img/No-data-messages/No-Transactions.png')}
            height="160px"
            width="160px"
            alt="No-data"
          />
        );
      }
      case 'NO_SERVICE': {
        return (
          <img
            className="justify-content-center"
            src={require('../../static/img/No-data-messages/No-Services.png')}
            height="160px"
            width="160px"
            alt="No-data"
          />
        );
      }
      case 'NO_REPORTS': {
        return (
          <img
            className="justify-content-center"
            src={require('../../static/img/No-data-messages/No-Services.png')}
            height="160px"
            width="160px"
            alt="No-data"
          />
        );
      }
      case 'NO_DASHBOARD': {
        return (
          <img
            className="justify-content-center"
            src={require('../../static/img/No-data-messages/No-Dashboard.png')}
            height="160px"
            width="160px"
            alt="No-data"
          />
        );
      }
      case 'NO_ACTIVITY': {
        return (
          <img
            className="justify-content-center"
            src={require('../../static/img/No-data-messages/No-Activity.png')}
            height="160px"
            width="160px"
            alt="No-data"
          />
        );
      }
      case 'NO_ACCOUNTS': {
        return (
          <img
            className="justify-content-center"
            src={require('../../static/img/No-data-messages/No-Accounts.png')}
            height="160px"
            width="160px"
            alt="No-data"
          />
        );
      }
      case 'NO_TASKS': {
        return (
          <img
            className="justify-content-center"
            src={require('../../static/img/No-data-messages/No-Consumers-1.png')}
            height="160px"
            width="160px"
            alt="No-data"
          />
        );
      }
      case 'NO_ATTACHMENTS': {
        return (
          <img
            className="justify-content-center"
            src={require('../../static/img/No-data-messages/No-Attachments.png')}
            height="160px"
            width="160px"
            alt="No-data"
          />
        );
      }
      case 'NO_NOTIFICATIONS': {
        return (
          <img
            className="justify-content-center"
            src={require('../../static/img/No-data-messages/No-Notifications.png')}
            height="160px"
            width="160px"
            alt="No-data"
          />
        );
      }
      default:
        break;
    }
  }, [type]);

  return (
    <>
      <div className={`text-center ${noTopMargin ? '':'mt-70'}`}>
        {handleShowALlNoDataImages}
        <br />
        <span className="color-light-gray"> {message} </span>
      </div>
    </>
  );
};

NoDataMessage.propTypes = {
  type: PropTypes.string,
  message: PropTypes.string,
  noTopMargin: PropTypes.any,
};

export { NoDataMessage };
